<app-resp-popup-title>Anlagestammdaten</app-resp-popup-title>
<app-resp-popup-content style="max-height: 65vh;">
  @if (this.layout) {
    <div style="min-width: 25vw">
      <ul>
        @for (category of layout.categories; track category) {
          <li>
            <span class="categoryLabel">{{ category.label }}</span>
            <ul>
              @for (field of category.fields; track field) {
                <ng-container
                  *ngTemplateOutlet="fieldTemplate; context: { field: field }"
                  >
                </ng-container>
              }
            </ul>
            <ul>
              @for (group of category.groups; track group) {
                <li>
                  <span class="groupLabel">{{ group.label }}</span>
                  <ul>
                    @for (field of group.fields; track field) {
                      <ng-container
                        *ngTemplateOutlet="fieldTemplate; context: { field: field }"
                        >
                      </ng-container>
                    }
                  </ul>
                </li>
              }
            </ul>
          </li>
        }
      </ul>
    </div>
  }
</app-resp-popup-content>
<ng-template #fieldTemplate let-field="field">
  <li [ngClass]="{ eyeCatcher: field.attributes.isEyeCatching }">
    {{ field.label }}: {{ getValueFromFieldID(field.id) }}
  </li>
</ng-template>
